import DomainError from "domain/error/DomainError";
import type { DomainErrorCode } from "domain/error/DomainErrorCodes";
import type { DomainErrorSeverity } from "domain/error/DomainError";
import DomainErrorCodes from "domain/error/DomainErrorCodes";
import type { ApiErrorBody } from "./createApiError";

const DefaultApiErrorMap: Record<string, DomainErrorCode | [DomainErrorCode, DomainErrorSeverity]> = {
    [DomainErrorCodes.SESSION_EXPIRED]: [DomainErrorCodes.SESSION_EXPIRED, "warning" as const],
    [DomainErrorCodes.TOKEN_EXPIRED]: [DomainErrorCodes.TOKEN_EXPIRED, "warning" as const],
    [DomainErrorCodes.TOKEN_NOT_FOUND]: [DomainErrorCodes.TOKEN_NOT_FOUND, "warning" as const],
    [DomainErrorCodes.TOKEN_ALREADY_VERIFIED]: [DomainErrorCodes.TOKEN_ALREADY_VERIFIED, "warning" as const],
    [DomainErrorCodes.LOCAL_GIFTCARD_INVALID_TYPE]: [DomainErrorCodes.LOCAL_GIFTCARD_INVALID_TYPE, "warning" as const],
    [DomainErrorCodes.LOCAL_GIFTCARD_NOT_FOUND]: [DomainErrorCodes.LOCAL_GIFTCARD_NOT_FOUND, "warning" as const],
    [DomainErrorCodes.APPROVER_NOT_FOUND]: [DomainErrorCodes.APPROVER_NOT_FOUND, "warning" as const],
    403: [DomainErrorCodes.FORBIDDEN, "warning" as const],
    401: [DomainErrorCodes.FORBIDDEN, "warning" as const],
    404: [DomainErrorCodes.NOT_FOUND, "warning" as const],
    400: [DomainErrorCodes.BAD_REQUEST, "warning" as const],
};

export function mapApiErrorToDomainError(
    body: ApiErrorBody,
    customMap?: Record<string, DomainErrorCode | [DomainErrorCode, DomainErrorSeverity]>,
): DomainError {
    const map = { ...DefaultApiErrorMap, ...customMap };
    const errorBodyMessage = (body.code ? map[body.code] : undefined) ?? map[body.statusCode];
    const [errorCode, errorSeverity] = Array.isArray(errorBodyMessage)
        ? errorBodyMessage
        : [errorBodyMessage ?? DomainErrorCodes.UNKNOWN_ERROR, "error" as const];
    const resolvedCode = (DomainErrorCodes[errorCode] ? errorCode : DomainErrorCodes.UNKNOWN_ERROR) as DomainErrorCode;

    // Solo para 400 sin `code` de negocio (ej. errores de validación de class-validator) mostramos
    // el mensaje crudo del API en vez del genérico. Se evita para otros status (5xx, etc.) para no
    // filtrar mensajes internos del servidor.
    const details =
        !body.code && resolvedCode === DomainErrorCodes.BAD_REQUEST && body.message
            ? Array.isArray(body.message)
                ? body.message.join(". ")
                : body.message
            : undefined;

    return new DomainError(resolvedCode, errorSeverity, details);
}
